module.exports = __webpack_public_path__ + "img/zh.0e9ae28e.png";